import { TypeChecker } from '@attain-apps/type-guards'

export interface AtnDsNumberConfig {
  /**
   * Override default min values
   *
   * @default -Infinity
   */
  min?: number
  /**
   * Override default max values
   */
  /** @default +Infinity */
  max?: number
  /**
   * override default suffix
   *
   * @default ''
   */
  suffix?: string
  /**
   * override default prefix
   *
   * @default ''
   */
  prefix?: string
  /**
   * override default precision
   *
   * @default 2
   */
  precision?: number
}

export namespace AtnDsNumberConfig {
  export const isConfig = TypeChecker.Factory.object<AtnDsNumberConfig>({
    max: TypeChecker.Factory.optional(TypeChecker.isNumber),
    min: TypeChecker.Factory.optional(TypeChecker.isNumber),
    precision: TypeChecker.Factory.optional(TypeChecker.isNumber),
    prefix: TypeChecker.Factory.optional(TypeChecker.isString),
    suffix: TypeChecker.Factory.optional(TypeChecker.isString),
  })
}
